import PickListDropdown, { SinglePickListDropdown, TabPickListDropdown } from "./PickListDropdown";
PickListDropdown.SinglePickListDropdown = SinglePickListDropdown;
PickListDropdown.TabPickListDropdown = TabPickListDropdown;
export default PickListDropdown;